module.exports = __webpack_public_path__ + "img/pup13.af749091.jpg";